import "./range.scss";
import React from "react";

type RangeProps = Omit<
    React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    "min" | "max" | "value" | "onChange"
>;

interface Props extends RangeProps {
    min: number;
    max: number;
    value: number;
    onChange: (value: number) => void;
}

const Range: React.FunctionComponent<Props> = ({
    onChange,
    value,
    min,
    max,
    style,
    ...props
}) => {
    const [ internalValue, setInternalValue ] = React.useState(() => {
        return value.toString();
    });

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInternalValue(e.currentTarget.value);

        let parsed = parseFloat(e.currentTarget.value);

        if(parsed < min) {
            parsed = min;
        } else if(parsed > max) {
            parsed = max;
        }

        onChange(parsed);
    };

    const percentage = (value - min) * 100 / (max - min);

    return (
        <input
            {...props}
            type="range"
            min={min}
            max={max}
            value={internalValue}
            style={{
                ...style,
                backgroundSize: `${Math.round(percentage * 100) / 100}% 100%`,
            }}
            onChange={onInputChange}
        />
    );
};

export default Range;
